<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark" id="myNav" style="z-index: 2;">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" 
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse mx-auto" id="navbarToggleExternalContent" data-bs-theme="dark">
        <ul class="navbar-nav mx-auto">
          <li><img src="../../assets/logo.png" style="width: 50px;" alt=""></li>
          <li class="nav-item active">
            <a class="nav-link mx-lg-3" href="../">Home</a>
          </li>
          <li class="nav-item active dropdown">
            <a class="nav-link mx-lg-3 dropdown-toggle" type="button" id="dropdownMenuButton1" aria-expanded="false">Services</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/organizational-services">Organizational</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/business-owner">Business Owners</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/services-manufacturers">manufacturers</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/merchant-services">Merchants And Traders</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/traders-services">Traders</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/technology-consulting-service">Design Technology</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../services/data-management-service">Data Management And Analysis</a></li>
            </ul>
          </li>
          <li class="nav-item active dropdown">
            <a class="nav-link mx-lg-3" href="../tests">Tests</a>
          </li>
          <li class="nav-item active dropdown">
            <a class="nav-link mx-lg-3 dropdown-toggle" type="button" id="dropdownMenuButton1" aria-expanded="false">Nabaco Trader</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="../trade/trade-assistant">Trade Assistant</a></li>
              <!-- <li><a class="dropdown-item" style="cursor: pointer;">تحلیل ها</a></li> -->
              <!-- <li><a class="dropdown-item" style="cursor: pointer;">سوالات متداول</a></li> -->
              <li><a class="dropdown-item" style="cursor: pointer;" href="../report-view">Reports</a></li>
            </ul>
          </li>
          <li class="nav-item active dropdown">
            <a class="nav-link mx-lg-3 dropdown-toggle" type="button" id="dropdownMenuButton1" aria-expanded="false">Academy</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="../academy">Academy</a></li>
              <li><a class="dropdown-item" href="../academy/period">Courses</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;" href="../academy/category">Categories</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link mx-lg-3" href="#">Why Nabaco?</a>
          </li>
          <!-- <li class="nav-item active dropdown">
            <a class="nav-link mx-3 dropdown-toggle" type="button" id="dropdownMenuButton1" aria-expanded="false">راهنما</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" >راهنمای استفاده</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;">از کجا شروع کنم؟</a></li>
              <li><a class="dropdown-item" style="cursor: pointer;">سوالات متداول</a></li>
            </ul>
          </li> -->
          <li class="nav-item active dropdown">
            <a class="nav-link mx-lg-3 dropdown-toggle" type="button" id="dropdownMenuButton1" aria-expanded="false">Nabaco Club</a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item"  href="../vip-club">VIP Club</a></li>
              <!-- <li><a class="dropdown-item" style="cursor: pointer;">درآمد غیرفعال</a></li> -->
              <!-- <li><a class="dropdown-item" style="cursor: pointer;">ایونت ها</a></li> -->
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link mx-lg-3" href="../about">About Us</a>
          </li>
          <li class="nav-item">
            <a class="nav-link mx-lg-3" href="../contact">Contact Us</a>
          </li>
          <li class="nav-item">
            <img src="../../assets/Iran.png" width="30px" style="margin-top: 10px;margin-left: 5px;cursor: pointer;" alt="" @click="setLang('fa')">
            <img src="../../assets/England.png" width="30px" style="margin-top: 10px;margin-left: 5px;cursor: pointer;" alt="" @click="setLang('en')">
            <!-- <FontAwesomeIcon icon="fa-solid fa-globe" class="fs-5 nav-link d-inline" style="cursor: pointer;" @click="setLang()"/> -->
          </li>
          <li>
            <button class="btn-border-gold mx-3 pt-1 mt-1" style="font-size: 14px;" @click="router.push({name:'sign-in'})">Sign in</button>
          </li>
        </ul>
      </div>
    </nav>
  </template>
  
<script>
  import { defineComponent, ref } from 'vue';
  import { useRouter } from 'vue-router';
  // import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faGlobe } from '@fortawesome/free-solid-svg-icons';
  
  export default defineComponent({
    components: { },
    setup() {
      const router = useRouter()
      const credits = ref(localStorage.getItem('credits'))
      const user = ref(localStorage.getItem('id'))
      library.add(faGlobe)

      function logout(){
        localStorage.removeItem('name')
        localStorage.removeItem('id')
        localStorage.removeItem('family')
        localStorage.removeItem('phone')
        router.push({name:'sign-in'})
      }

      function gotoDashboard(){
        router.push({name:'dashboard',params:{id:localStorage.getItem('id')}})
      }

      function setLang(lang) {
        if (lang=='en' && localStorage.getItem('lang')!='en') {
          localStorage.setItem('lang','en')
          window.location.reload();
        }
        else if ((lang=='fa' && localStorage.getItem('lang')!='fa') || !localStorage.getItem('lang')) {
          localStorage.setItem('lang','fa')
          window.location.reload();
        }
      }

      return {
        router,
        credits,
        user,
        setLang,
        logout,
        gotoDashboard
      }
  
    },
  })
</script>
<style scoped lang="scss">
*{
  direction: ltr;
  font-family: Shabnam !important;
  text-align: center;
}
.navbar {
  background: linear-gradient(90deg, var(--blue) 0%, #000 100%);
  box-shadow: none !important;
  .nav-link{color: white !important;padding-top: 13px;}
  border: none !important;
  position: fixed; /* Set the navbar to fixed position */
  top: 0; /* Position the navbar at the top of the page */
  width: 100%; /* Full width */
}

.nav-colored {
  background: white !important;
  .nav-link {
    color: black !important;
  }
  .nav-link1 {
    color: black;
  }
}

.nav-link1 {
  color: white;
}

.dropdown:hover .dropdown-menu {
   display: block;
   margin-top: 0;
}

</style>
  